import React from "react"
import { getLocale } from "@/_services/localization"
import { momentDateFormat } from "basikon-common-utils"

class DateEditor extends React.Component {
  constructor(props) {
    super(props)
    this.inputRef = React.createRef()

    this.state = {
      format: momentDateFormat(getLocale()),
    }
  }

  componentDidMount() {
    if (this.inputRef.current) this.inputRef.current.focus()
  }

  handleChange = event => {
    const { onChange } = this.props
    onChange(event.target?.value)
  }

  handleKeyDown = event => {
    const { format } = this.state
    const { onKeyDown } = this.props

    if (!["Backspace", "Delete"].includes(event.key)) {
      const separator = format.includes("-") ? "-" : format.includes("/") ? "/" : format.includes(".") ? "." : "/"
      if (event.target?.value && typeof event.target.value === "string") {
        if (event.target.value.length === 2 && !event.target.value.endsWith(separator)) {
          event.target.value = event.target.value + separator
        } else if (event.target.value.length === 5 && !event.target.value.endsWith(separator) && event.target.value.split(separator).length < 3) {
          event.target.value = event.target.value + separator
        }
      }
    }

    onKeyDown(event)
  }

  render() {
    const { format } = this.state
    const { value } = this.props

    return (
      <input
        ref={this.inputRef}
        type="text"
        value={value}
        maxLength={10}
        placeholder={format}
        onChange={this.handleChange}
        onKeyDown={this.handleKeyDown}
      />
    )
  }
}

export default DateEditor
